


import TiwiMixin from '../mixins/TiwiMixin';
import CommentField from './CommentCard';
import CommentCard from './CommentCard';

export default {
  mixins: [ TiwiMixin ],
  props: {
    comment: {
      required: true,
      type: Object,
    },
    parentPostId: {
      required: false,
      type: Number,
    },
    onReplySubmit: {
      required: false,
      type: Function,
    },
  },
  data() {
		return {
      new_reply: false,
      show_responses: false,
		}
	},
  mounted: function() {
    this.new_reply = false;
	},
  methods: {
    addReply: function() {
      this.new_reply = !this.new_reply;
    },
    submitComment: function() {
      this.new_reply = false;
      this.onReplySubmit();
    }
  },
}
